import React, {useEffect, useState} from "react";
import {Paper} from "@mui/material";
import {Col, Row} from "reactstrap";
import NotificationsFormView from "./sections/form";
import NotificationHistoryView from "./sections/history";
import {useConfigureNotebook} from "../../../../../hooks/use-notebook-config";
import useAccessLevels from "../../../../../hooks/use-access-levels";
import useBehavioralAnalyticsTool from "../../../../../hooks/use-behavioural-analytics-tool";

const UserNotificationsListView = () => {
    const [selectedHistory, setSelectedHistory] = useState(null)
    const {configureNotebookTags} = useConfigureNotebook('user-notifications-list-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();
    const operatorAccessLevels = useAccessLevels();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool for the view
     */
    useEffect(() => {
        configureNotebookTags((noteTags) => noteTags.userNotificationsList);
        configureBehavioralTool((tags) => tags.userNotificationsList);
    }, [configureBehavioralTool, configureNotebookTags]);

    return (
        <>
            <Row className='no-gutters w-100 align-items-start justify-content-center notifications-view'>
                <Paper className='paper w-100 px-3 py-2 flex-wrap justify-content-between align-items-start'>
                    {
                        operatorAccessLevels.packages.notifications.manageCustomerNotifications &&
                        <Col xs={12} lg={6} className={''}>
                            <NotificationsFormView
                                notificationHistory={selectedHistory}
                            />
                        </Col>
                    }
                    <Col xs={12} lg={operatorAccessLevels.packages.notifications.manageCustomerNotifications ? 6 : 12} className={'pl-0' +
                        ' pl-lg-4'}>
                        <NotificationHistoryView
                            setSelectedHistory={setSelectedHistory}
                        />
                    </Col>
                </Paper>
            </Row>
        </>
    )
}

export default UserNotificationsListView;
